/* eslint-disable no-underscore-dangle */
const minZoom = (window as any)._env_.REACT_APP_MIN_ZOOM_LEVEL
  ? parseFloat((window as any)._env_.REACT_APP_MIN_ZOOM_LEVEL)
  : 6.5;
const maxZoom = (window as any)._env_.REACT_APP_MAX_ZOOM_LEVEL
  ? parseFloat((window as any)._env_.REACT_APP_MAX_ZOOM_LEVEL)
  : 15;
const imageDimensions = (window as any)._env_.REACT_APP_IMAGE_DIMENSIONS
  ? (window as any)._env_.REACT_APP_IMAGE_DIMENSIONS.split(',')
  : [1500, 1500];
const maxExtent = (window as any)._env_.REACT_APP_MAX_EXTENT?.split(',')
  .map((v: string) => parseFloat(v)) || [-2195072, 3702197, -1583294, 4011457];

const initialZoom = (window as any)._env_.REACT_APP_INITIAL_ZOOM_LEVEL
  ? parseInt((window as any)._env_.REACT_APP_INITIAL_ZOOM_LEVEL, 10)
  : minZoom;
const initialCenter = (window as any)._env_.REACT_APP_INITIAL_CENTER_COORDINATES?.split(',')
  .map((v: string) => parseFloat(v)) || [-16.778066, 32.694293]; // long, lat

const connectionTimeout = (window as any)._env_.REACT_APP_CONNECTION_TIMEOUT
  ? parseInt((window as any)._env_.REACT_APP_CONNECTION_TIMEOUT, 10)
  : 30000;

export {
  initialZoom, initialCenter, minZoom, maxZoom, imageDimensions, maxExtent, connectionTimeout,
};
